import { render, staticRenderFns } from "./selfDataCenter.vue?vue&type=template&id=88bf2698&scoped=true"
import script from "./selfDataCenter.vue?vue&type=script&lang=js"
export * from "./selfDataCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bf2698",
  null
  
)

export default component.exports